import React from "react";
import { TrackingCaseEditTemplate } from "themes/application/tracking-case/pages";
import { observer } from "mobx-react";
import { TrackingCaseEditViewStore } from "application/tracking-case/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new TrackingCaseEditViewStore(rootStore), "trackingCaseEditViewStore")
@observer
class TrackingCaseEdit extends React.Component {
	render() {
		return <TrackingCaseEditTemplate {...this.props} />;
	}
}

export default TrackingCaseEdit;